import { useState } from "react";
import { useBoolean } from "@fluentui/react-hooks";
import { Link } from "@fluentui/react/lib/Link";
import { Text } from "@fluentui/react/lib/Text";

import { omitNullish, safeUnique } from "Utils/Array";
import { WithTranslator } from "Components/Generic/Translator";
import { getTranslatedSingularFieldLabel } from "Utils/Field";
import { getItemType } from "Utils/Item";
import { isNullish } from "Utils/Null";
import { ImageSearchIcon } from "@fluentui/react-icons-mdl2";
import { ImageCarousel } from "./ImageCarousel";
import { IImageListValueProps } from "./IImageListValueProps";
import { useImageListValueStyles } from "./UseImageListValueStyles";

export const ImageListValue = WithTranslator(
  ({
    translator, fieldName, placeholder, item
  }: IImageListValueProps): JSX.Element => {
    const [isModalOpen, { setTrue: showModal, setFalse: hideModal }] = useBoolean(false);
    const [selectedImg, setSelectedImg] = useState(0);
    const styles = useImageListValueStyles();

    const valueList = item?.[fieldName] as string[];
    if (isNullish(valueList)) {
      return <Text variant="smallPlus">{placeholder}</Text>;
    }

    const safeValueList = omitNullish(safeUnique(valueList));
    return (
      <>
        <ImageSearchIcon className={styles.icon} />
        {safeValueList.slice(0, 3).map((url, index) => (
          <Link
            // eslint-disable-next-line react/no-array-index-key
            key={url}
            title={url}
            onClick={() => {
              setSelectedImg(index);
              showModal();
            }}
          >
            {`${getTranslatedSingularFieldLabel(fieldName, getItemType(item), translator)} ${index + 1}`}
            &nbsp;&nbsp;
          </Link>
        ))}
        <ImageCarousel
          imgList={safeValueList}
          isModalOpen={isModalOpen}
          hideModal={hideModal}
          selectedImg={selectedImg}
        />
      </>
    );
  }
);
